import React from "react";
import { Collapse, Typography, Alert } from "antd";

const { Panel } = Collapse;
const { Paragraph, Title } = Typography;

const TransferInfo = () => {
  return (
    <div
      className="transfer_info pl4"
      style={{ maxWidth: "800px", paddingTop: "2rem" }}
    >
      {/* Alert Section */}
      <Alert
        message="For Registered recipients:"
        description={
          <>
            <Paragraph>
              No transactions are allowed for the first 30 minutes after adding
              or modifying a recipient.
            </Paragraph>
            <Paragraph>
              From 30 minutes to 24 hours, transfers are limited to INR 50,000
              per day across all new/modified recipients.
            </Paragraph>
            <Paragraph>
              After 24 hours, transfers up to your daily limit are allowed.
            </Paragraph>
            <Paragraph>
              Recipients added between 9:30 AM and 6 PM follow this cooling
              period; those added after or on holidays activate the next working
              day.
            </Paragraph>
          </>
        }
        type="info"
        showIcon
        style={{ marginBottom: "20px" }}
      />

      {/* Collapsible Panels for each transfer type */}

      <div key="1">
        <h3>IMPS</h3>
        <Paragraph>Available 24x7, 365 days, including holidays.</Paragraph>
        <Paragraph>Max ₹2,00,000. Instant, 24x7, including holidays.</Paragraph>
        <Paragraph>
          Works across all participating banks and mobile platforms.
        </Paragraph>
      </div>
      <br />
      <div key="2">
        <h3>NEFT</h3>
        <Paragraph>Available 24x7, 365 days in batches.</Paragraph>
        <Paragraph>
          Credit to beneficiary depends on the destination bank.
        </Paragraph>
        <Paragraph>No max limit. 24x7, processed in hourly batches.</Paragraph>
      </div>
      <br />
      <div key="3">
        <h3>RTGS</h3>
        <Paragraph>
          Available 24x7, except during start/end-of-day processes.
        </Paragraph>
        <Paragraph>
          Works in real-time; only for RTGS-participating banks.
        </Paragraph>
        <Paragraph>Min transfer ₹2,00,000, no max limit.</Paragraph>
        <Paragraph>Recurring payments are not allowed.</Paragraph>
      </div>
      <br />
      <div key="4">
        <h3>UPI</h3>
        <Paragraph>
          Enter UPI/BHIM virtual address and check availability.
        </Paragraph>
        <Paragraph>Ensure beneficiary details are correct.</Paragraph>
        <Paragraph>
          Daily transfer limit: ₹1,00,000 per day/transaction.
        </Paragraph>
      </div>
    </div>
  );
};

export default TransferInfo;
